export const shippingMethodOptions = [
  {
    method: "Standard Shipping",
    price: 3.5,
    icon: "fas fa-2x fa-truck",
    id: "standardShipping",
  },
];
